import { DataTable } from '@/components/ui/data-table/DataTable';
import { columns } from './columns';
import { columnsDedicateInstance } from '../InstanceTable/type';
import { useNavigate } from 'react-router-dom';
type Props = {
  data: columnsDedicateInstance[];
};
const TerminatedInstanceTable = ({ data = [] }: Props) => {
  const navigate = useNavigate();
  return (
    <div className="">
      <DataTable
        columns={columns}
        data={data}
        onClickRow={(row) => {
          navigate(row.getValue('id'));
        }}
      />
    </div>
  );
};

export default TerminatedInstanceTable;
